// shapes
import { IEntity } from '../../../../../../../types/api/entities/IEntity';
import ILink from '../../../../../../../types/ILink';
import { TopUserResponse } from '../api/TopUserResponse';
import { TopContentSuggest } from '../api/TopContentSuggest';

export interface LinkableSuggestResultEntity extends IEntity {
  pageLink: ILink;
}

export interface AllContentResults extends LinkableSuggestResultEntity {
  type: 'allContentResult';
}

export interface TopContentResult extends TopContentSuggest {
  type: 'topContentResult';
}

export function TopContentResult(contentSuggest: TopContentSuggest): TopContentResult {
  return { ...contentSuggest, type: 'topContentResult' };
}

// Result => internal use
export interface TopUserResult extends TopUserResponse {
  type: 'topUserResult';
}

export interface SearchSuggestResult extends IEntity {
  type: 'searchSuggestResult';
  pageLink: ILink;
  title: string;
}

export function TopUserResult(response: TopUserResponse): TopUserResult {
  return { ...response, type: 'topUserResult' };
}

export interface TopKeywordResult extends IEntity {
  type: 'topKeywordResult';
  title: string;
}

export function TopKeywordResult(id: string, title?: string): TopKeywordResult {
  return { id, title: title || id, type: 'topKeywordResult' };
}

export interface AllUserResult extends LinkableSuggestResultEntity {
  type: 'allUserResult';
}

export type SelectType = 'select' | 'selectAndGo' | 'multi-select';
